import { Configuration, LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

const authEnvValues = {
  REACT_APP_MSAL_CLIENT_ID: process.env.REACT_APP_MSAL_CLIENT_ID,
  REACT_APP_MSAL_TENANT_ID: process.env.REACT_APP_MSAL_TENANT_ID,
  REACT_APP_MSAL_API_SCOPE: process.env.REACT_APP_MSAL_API_SCOPE,
};

export const missingAuthEnvVars = Object.entries(authEnvValues)
  .filter(([, value]) => !value?.trim())
  .map(([envKey]) => envKey);

export const isAuthConfigured = missingAuthEnvVars.length === 0;
export const authProviderConfigurationError = isAuthConfigured
  ? null
  : "There was an issue configuring the auth provider.";

const msalClientId = authEnvValues.REACT_APP_MSAL_CLIENT_ID ?? "";
const msalTenantId = authEnvValues.REACT_APP_MSAL_TENANT_ID ?? "";
const msalApiScope = authEnvValues.REACT_APP_MSAL_API_SCOPE ?? "";

export const msalConfig: Configuration = {
  auth: {
    clientId: msalClientId,
    authority: `https://login.microsoftonline.com/${msalTenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: `${window.location.origin}/login`,
  },
  cache: {
    cacheLocation: "localStorage", // "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: msalApiScope ? [`api://${msalClientId}/${msalApiScope}`] : [],
  prompt: "login",
};

export const silentRequest = {
  scopes: msalApiScope ? [`api://${msalClientId}/${msalApiScope}`] : [],
};
